<template>
    <UForm class="w-full mb-8" :schema="schema" :state="state" @submit="onSubmit">
        <div class="flex justify-between items-center mb-2 px-2" v-if="username">
            <UiComponentTypography class-name="text-center" variant="caption">
                شما در حال ورود با {{ username }} هستید
            </UiComponentTypography>
            <UButton variant="link" @click="emits('change:type', 'username')">
                <span>تغییر</span>
            </UButton>
        </div>
        <UtilsFormBuilder form-size="xs" class="flex-wrap" :data="form" v-model="state" />
        <div class="flex justify-between mt-6">
            <UButton
                size="xs"
                variant="link"
                color="gray"
                :padded="false"
                :disabled="isLoading"
                @click="emits('change:type', 'otp')"
            >
                <span>ورود با رمز یک‌بار مصرف</span>
            </UButton>
            <UButton
                size="xs"
                variant="link"
                color="gray"
                :padded="false"
                :disabled="isLoading"
                @click="emits('change:type', 'forgot')"
            >
                <span>فراموشی رمز عبور</span>
            </UButton>
        </div>
        <div class="flex justify-center mt-4">
            <UButton type="submit" :loading="isLoading" block>
                <span>ورود</span>
            </UButton>
        </div>
    </UForm>
</template>

<script lang="ts" setup>
import type { IDynamicKey, IForm } from "~/libs/types/general";
import { object, string, type InferType } from "yup";
import type { FormSubmitEvent } from "#ui/types";
import password from "~/libs/schemas/auth/password.json";

const emits = defineEmits(["send-data", "change:type"]);

const props = defineProps({
    isLoading: {
        type: Boolean,
        default: false,
    },
    username: String,
});

const form: Ref<IForm<any>[]> = ref(password as IForm<any>[]);

const schema = object({
    password: string().min(8).required("وارد کردن این فیلد الزامی‌ست"),
});

type Schema = InferType<typeof schema>;

const state: IDynamicKey<string | undefined> = reactive({
    username: undefined,
    password: undefined,
});

onMounted(() => {
    state.username = props.username;
});

async function onSubmit(event: FormSubmitEvent<Schema>) {
    if (event.data) emits("send-data", event.data.password);
}
</script>

<style></style>
